import { IOmniaSession } from "../../types"
import { defineDirective } from "../../utils/angular"
import { getSelectedYearsLabel } from "../../utils/date"
import { isFunction } from "../../utils/utils"

/** @internal */
export interface YearVm {
    readonly year: number
    readonly required: boolean
    selected: boolean
}

/** @internal */
export class YearsPickerCtrl {

    static create(): ng.IDirective {
        return defineDirective(YearsPickerCtrl, "shared/components/years/years.html", {
            selection: "=",
            availableYears: "<",
            requiredYears: "<",
            onChange: "&"
        })
    }

    open: boolean
    onChange: Function

    years: YearVm[]

    private _selection: number[]
    private _yearsText: string

    availableYears: number[]
    requiredYears: number[]

    static $inject = ["OmniaSession"]

    constructor(private session: IOmniaSession) {
    }

    $onInit() {

        const years = this.availableYears || this.session.getCroppingYears().map(y => y.Year)

        const required = new Set(this.requiredYears || [])

        this.years = (years || [])
            .sort((y1, y2) => y2 - y1)
            .map(y => ({ year: y, selected: required.has(y), required: required.has(y) }))

        this.updateYears()

    }

    get yearsText() {
        return this._yearsText
    }

    get selection() {
        return this._selection
    }

    set selection(s: number[]) {
        this._selection = s
        this.updateYears()
    }

    updateYears() {
        if (this.years) {
            this.years.forEach(y => y.selected = (this._selection && this._selection.some(s => s == y.year)))
            this._yearsText = getSelectedYearsLabel(this._selection, null)
        }
    }

    updateSelection() {

        this._selection = this.years.filter(y => y.selected).map(y => y.year)
        this._yearsText = getSelectedYearsLabel(this._selection, null)

        if (this.onChange) {
            const r = this.onChange()
            if (isFunction(r)) {
                r(this._selection)
            }
        }

    }

    selectAll(select: boolean) {
        this.years.forEach(y => y.selected = select || y.required)
    }

    canCommit() {
        return this.years && this.years.some(y => y.selected)
    }

    close(commit: boolean) {

        if (commit) {
            this.updateSelection()
        }

        this.open = false
    }
}
